import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
// import { PopupCierreSesionComponent } from 'src/app/shared/popup/popup-cierre-sesion/popup-cierre-sesion.component';
import { AuthService } from './auth.service';
import { AuthStatus } from 'src/app/models/auth-status.enum';
import { PopupCierreSesionComponent } from 'src/app/core/shared/popup/popup-cierre-sesion/popup-cierre-sesion.component';
import { LoggerService } from 'src/app/core/logger.service';
// import { PopupCierreSesionComponent } from 'src/app/shared/popup-cierre-sesion/popup-cierre-sesion.component';

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {

  // private sessionTimeout: number; // Tiempo de espera de la sesión en milisegundos
  // private sessionPopupThreshold: number; // Umbral para mostrar el popup en milisegundos
  private readonly EXPIRATION_KEY = 'token_expiration';
  // private readonly INACTIVITY_TIMEOUT = 2 * 60 * 60 * 1000; // 2 horas en milisegundos
  // private readonly INACTIVITY_TIMEOUT = 10 * 1000; // 2 horas en milisegundos
  private inactivityTimerId: any;
  private tokenCheckIntervalId: any;
  private popupOpen = false;

  authService = inject(AuthService);

  constructor(private dialog: MatDialog, private logger: LoggerService) {
  }

  startInactivityTimer() {

    // Si no está autenticado salga de la función
    if(this.authService.authStatus() === AuthStatus.notAuthenticated) {
      return;
    }

    // this.resetInactivityTimer();

    // // Reiniciar el temporizador en eventos de interacción del usuario
    // window.addEventListener('mousemove', this.resetInactivityTimer.bind(this));
    // window.addEventListener('click', this.resetInactivityTimer.bind(this));
    // window.addEventListener('keypress', this.resetInactivityTimer.bind(this));
    // window.addEventListener('scroll', this.resetInactivityTimer.bind(this));

    // Verificar periódicamente si el token ha caducado
    this.tokenCheckIntervalId = setInterval(() => this.checkTokenExpiration(), 10 * 1000); // Cada minuto
  }

  private resetInactivityTimer() {

    // Si no está autenticado salga de la función
    if(this.authService.authStatus() === AuthStatus.notAuthenticated) {
      return;
    }

    clearTimeout(this.inactivityTimerId);

    // this.inactivityTimerId = setTimeout(() => {
    //   const actualTime = new Date().getTime();
    //   this.logger.debug('Actual Time:', actualTime);
    //   this.logger.debug("POPUP POR INACTIVIDAD");
    //   this.showExpirationPopup('inactivity');
    // }, this.INACTIVITY_TIMEOUT);
  }

  private checkTokenExpiration() {
    const expirationTime = localStorage.getItem(this.EXPIRATION_KEY);
    const currentTime = new Date().getTime();

    if (expirationTime && Number(expirationTime) <= currentTime) {
      this.logger.debug("POPUP POR TOKEN");
      this.showExpirationPopup('token');
    }
  }

  private showExpirationPopup(reason: 'inactivity' | 'token') {
    if (this.popupOpen) {
      return;
    }

    this.popupOpen = true;

    const dialogRef = this.dialog.open(PopupCierreSesionComponent, {
      disableClose: true,
      data: { reason }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.popupOpen = false;

      if (result === 'renew') {
        this.renewToken();
      } else if (result === 'logout') {
        this.logout();
      }
      // this.resetInactivityTimer();
    });
  }

  renewToken() {
    this.authService.renewToken();
  }

  logout() {
    this.clearTimers();
    this.authService.logout();
  }

  clearTimers() {
    clearTimeout(this.inactivityTimerId);
    clearInterval(this.tokenCheckIntervalId);
    this.popupOpen = false;
  }

}
